import PasswordRecoveryScreenConnector from './PasswordRecoveryScreenConnector';

export default PasswordRecoveryScreenConnector;
